import { map, first, shareReplay } from "rxjs/operators";
import { of, forkJoin, Observable } from "rxjs";

const _cache: Record<string, any> =
  typeof window === "undefined"
    ? {}
    : ((window["_api_cache_service_" as any] as any) = {});

const ApiCacheService = {
  withCache: (id: string, request: Observable<any>) => {
    if (_cache[id] === undefined) {
      _cache[id] = request.pipe(
        first(),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
    }

    return _cache[id];
  },
  /// Special case for config props and nav tokens
  withCache_Array: (
    id: string,
    keys: string[],
    requestCallback: (keys: string[]) => Observable<any>,
  ): Observable<any> => {
    if (_cache[id] === undefined) {
      _cache[id] = {};
    }

    const observables = [];
    const tokensToRequest = [];

    for (let i = 0; i < keys.length; i++) {
      const token = keys[i];

      if (_cache[id][token]) {
        observables.push(_cache[id][token]);
      } else {
        tokensToRequest.push(token);
      }
    }

    let requestToPass = of({});

    if (tokensToRequest.length !== 0) {
      requestToPass = requestCallback(tokensToRequest).pipe(
        first(),
        shareReplay({ bufferSize: 1, refCount: true }),
      );

      for (let i = 0; i < tokensToRequest.length; i++) {
        _cache[id][tokensToRequest[i]] = requestToPass;
      }
    }

    observables.push(requestToPass);

    return forkJoin(observables).pipe(
      map((responses: Record<string, any>) => {
        const result: Record<string, any> = {};

        for (let i = 0; i < responses.length; i++) {
          const response = responses[i];

          for (let j = 0; j < keys.length; j++) {
            const token = keys[j];
            if (response[token] !== undefined) {
              result[token] = response[token];
            }
          }
        }

        return result;
      }),
    );
  },
  /** Clears the cache for a specific key */
  clear: (id: string) => {
    if (_cache[id] !== undefined) {
      delete _cache[id];
    }
  },
};

export default ApiCacheService;
